'use client'

import { forwardRef, type ComponentProps } from 'react'
import { Link as LocaleLink, useRouter as useLocaleRouter } from './navigation-base'
import { useProgressLink, useProgressRouter } from '@/components/navigation/useProgressNavigation'

export const Link = forwardRef<HTMLAnchorElement, ComponentProps<typeof LocaleLink>>(function Link(props, ref) {
  const onClick = useProgressLink(props)
  return <LocaleLink {...props} ref={ref} onClick={onClick} />
})

export function useRouter() {
  return useProgressRouter(useLocaleRouter())
}
